import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import DescriptionIssueRow from '../DescriptionIssueRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import Order from '@hydra/routes/crawler/components/Order';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class DescriptionIssueTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.object.isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const toggles = get(this.props.project, 'crawls.edges[0].node.countTypesDescriptionIssues', [])
      .map(v => ({ identifier: v.type, ...v }));
    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('typeFilters', toggles)}
            checkedItems={this.props.filters.typeFilters}
            groups={toggles}
            name='typeFilters'
            label={<Translate content='crawler_description_issues' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('description')}
            value={this.props.filters.description}
            name='description'
            label={<Translate content='crawler_description_text' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_error_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} section='descriptionIssues'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_description_issues' size={{ sm: 2, md: 2 }} />
            <Order
              size={{ sm: 2, md: 2 }}
              onChange={this.props.onOrderChange('lenOrder')}
              order={this.props.order.lenOrder}
            >
              <Translate content='crawler_characters' />
            </Order>
            <Translate content='crawler_description_text' size={{ sm: 3, md: 4 }} />
            <Translate content='crawler_error_page_url' size={{ sm: 5, md: 4 }} />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={DescriptionIssueRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(DescriptionIssueTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
    fragment DescriptionIssueTable_project on Project
    @argumentDefinitions(
      offset: {type: "Int", defaultValue: 0},
      limit: {type: "Int", defaultValue: 20},
      typeFilters: {type: "[String]", defaultValue: []},
      lenOrder: {type: "Int", defaultValue: 0},
      description: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
      url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
    ) {
      host,
      crawls (offset: 0, limit: 1) {
        edges {
          node {
            countTypesDescriptionIssues(description: $description, url: $url) {
              type
              severity
              count
            },
            descriptionIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder, description: $description) {
              count
              edges {
                node {
                  ...DescriptionIssueRow_issue
                }
              }
            }
          }
        }
      }
    }`
  },
  graphql`
      query DescriptionIssueTable_RefetchQuery($offset: Int, $limit: Int, $typeFilters: [String], $lenOrder: Int, $description: TextFilters, $url: TextFilters, $host: String!) {
        project (host: $host) {
          ...DescriptionIssueTable_project @arguments(
            offset: $offset,
            limit: $limit,
            typeFilters: $typeFilters,
            url: $url,
            lenOrder: $lenOrder,
            description: $description
          )
        }
      }
    `
);
